import React from "react";
import { Rect, Transformer } from "react-konva";

const Rectangle = ({
  shapeProps,
  onSelect,
  x,
  y,
  width,
  height,
  fill,
  opacity,
  selected,
  draggable,
  handleDragStart,
  index,
  handleDragMove,
  id,
  rect,
  rects,
  setRects,
  canvasWidth,
  canvasHeight,
  handleMouseDown,
  updateSize,
  minScale,
  stroke,
  strokeWidth,
  dash,
  colorPickerVisible,
}) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (selected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [selected]);

  // TODO: set up boundaries based on the dimensions of the stage
  const handleDragEnd = (e) => {
    // check whether the rect's coordinates are outside the canvas
    // first x-axis, then y-axis

    setRects(
      rects.map((rect) => {
        if (rect.id === e.id + 1 && rect.x > canvasWidth - rect.width) {
          return {
            ...rect,
            x: canvasWidth - rect.width,
          };
        } else if (rect.id === e.id + 1 && rect.x < 0)
          return {
            ...rect,
            x: 0,
          };
        else return rect;
      })
    );
    setRects(
      rects.map((rect) => {
        if (rect.id === e.id + 1 && rect.y > canvasHeight - rect.height) {
          return {
            ...rect,
            y: canvasHeight - rect.height,
          };
        } else if (rect.id === e.id + 1 && rect.y < 0)
          return {
            ...rect,
            y: 0,
          };
        else return rect;
      })
    );
  };

  return (
    <React.Fragment>
      <Rect
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        name={"rect"}
        {...shapeProps}
        draggable={draggable}
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        opacity={opacity}
        stroke={stroke}
        strokeWidth={strokeWidth}
        dash={dash}
        onMouseDown={handleMouseDown}
        selected={selected}
        id={id}
        onDragEnd={(e) => {
          handleDragEnd(rect);
        }}
        onDragStart={() => {
          handleDragStart(rect);
        }}
        onDragMove={handleDragMove}
        onTransformEnd={(e) => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          updateSize(index, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY,
          });
        }}
      />
      {selected && (
        <Transformer
          ref={trRef}
          keepRatio={false}
          rotateEnabled={false}
          borderStrokeWidth={colorPickerVisible ? 0 : 1}
          borderDash={[4, 3]}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < minScale || newBox.height < minScale) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Rectangle;
